import { FC, PropsWithChildren } from 'react';
import Footer from './footer';
import Header from './header';

const Layout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="vh-100 d-flex flex-column">
      <Header />
      <div className="d-flex flex-grow-1">
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
